<template>
  <div class="listDemographic">
    <table>
      <thead>
        <tr>
          <th v-for="(header, index) in data.header" :key="index">{{header}}</th>
        </tr>
      </thead>
      <tbody class="loading" v-if="data.body.length == 0">
        <tr >
          <td :colspan="data.header.length">
            <adx-loading-primary />
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <template v-if="type == 'bar'">
          <tr v-for="(body, index) in data.body" :key="index">
            <td v-for="(content, key) in body" :key="key">
              <div class="wrap" v-if="key == 'user'">
                <div class="bar" :style="{width: content + '%'}"></div>
              </div>
              <div v-else-if="key == 'total'">
                <span>{{content}}</span>
              </div>
              <div class="wrap" v-else-if="key.toLowerCase().includes('percent')">
                <div class="bar" :style="{width: content + '%'}"></div>
                <span class="caption">{{content}}%</span>
              </div>
              <template v-else>{{content}}</template>
            </td>
          </tr>
        </template>
        <template v-else-if="type == 'bar-color'">
          <tr v-for="(body, index) in data.body" :key="index">
            <td v-for="(content, key) in body" :key="key">
              <div class="wrap" v-if="key == 'user'">
                <div class="bar-color" :style="{width: content + '%'}"></div>
              </div>
              <div v-else-if="key == 'total'">
                <span>{{content}}</span>
              </div>
              <div class="wrap" v-else-if="key.toLowerCase().includes('percent')">
                <div v-if="color == 'bar-green'" class="bar-green" :style="{width: content + '%'}"></div>
                <div v-if="color == 'bar-red'" class="bar-red" :style="{width: content + '%'}"></div>
                <div v-if="color == 'bar-yellow'" class="bar-yellow" :style="{width: content + '%'}"></div>
                <span class="caption">{{content}} Update</span>
              </div>
              <template v-else>{{content}}</template>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(body, index) in data.body" :key="index">
            <td v-for="(content, index) in body" :key="index">{{content}}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'

export default {
  name: 'adx-list-demographic',
  components: {
    'adx-loading-primary': LoadingPrimary,
  },
  props: {
    data: {
      required: false
    },
    type: {
      required: false
    },
    color: {
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>